'use strict';

module.exports = 'enhanceArray';